/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconShield = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M20.769 16.269L6.2 1.483a19.21 19.21 0 0 0-3.082 1.078 1.487 1.487 0 0 0-.868 1.362v1.239l15.384 15.379a11.924 11.924 0 0 0 3.135-4.272z" />
        <path d="M2.25 3.923v7.614c0 4.926 3.034 9.344 7.632 11.113l1.041.4a2.996 2.996 0 0 0 2.154 0l1.041-.4a11.908 11.908 0 0 0 7.632-11.113V3.923a1.488 1.488 0 0 0-.868-1.362A21.709 21.709 0 0 0 12 .75a21.709 21.709 0 0 0-8.882 1.811 1.488 1.488 0 0 0-.868 1.362z" />
      </g>
    </svg>
  ),
);
